module.exports = __webpack_public_path__ + "static/media/ic_filter-primary-active.50bb1094.svg";